(function () {
  var KEY = 'efp2-scheme';
  var root = document.documentElement;

  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function system() {
    return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light';
  }
  function current() { return root.getAttribute('data-efp2-scheme') || 'light'; }
  function paint(mode) {
    root.setAttribute('data-efp2-scheme', mode);
    var btns = document.querySelectorAll('[data-efp2-scheme-toggle]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      btns[i].setAttribute('title', mode === 'dark' ? 'Switch to light background' : 'Switch to dark background');
      btns[i].setAttribute('aria-label', btns[i].getAttribute('title'));
    }
  }
  function set(mode, remember) {
    if (remember) { try { localStorage.setItem(KEY, mode); } catch (e) {} }
    paint(mode);
  }
  set(stored() || system(), false);

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-efp2-scheme-toggle]') : null;
    if (!b) return;
    e.preventDefault();
    set(current() === 'dark' ? 'light' : 'dark', true);
  });

  if (window.matchMedia) {
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    var onChange = function () { if (!stored()) { paint(system()); } };
    if (mq.addEventListener) { mq.addEventListener('change', onChange); }
    else if (mq.addListener) { mq.addListener(onChange); }
  }
})();
